import { MI_TO_KM } from "./distanceUnits";

/**
 * Derive summary numbers from generated plan weeks (schedule + totalMileage), not from form re-rules.
 */

function countTrainingDaysFromSchedule(schedule) {
  if (!schedule || typeof schedule !== "object") return 0;
  return Object.values(schedule).filter(
    (v) =>
      typeof v === "string" &&
      v.trim() &&
      !/^rest$/i.test(v.trim())
  ).length;
}

/**
 * Typical training density: first week that is not onboarding (falls back to week 1).
 */
export function daysPerWeekFromPlan(planWeeks) {
  if (!Array.isArray(planWeeks) || planWeeks.length === 0) return null;
  const preferred = planWeeks.find((w) => {
    const f = String(w.focus || w.label || "").toLowerCase();
    return !f.includes("onboard");
  });
  const week = preferred || planWeeks[0];
  const n = countTrainingDaysFromSchedule(week?.schedule);
  return n > 0 ? n : null;
}

function parseEnduranceRunMiles(line, unitPreference) {
  if (typeof line !== "string" || /race day/i.test(line)) return null;
  if (!/\b(long run|saturday run)\b/i.test(line)) return null;
  const mm = line.match(/([\d.]+)\s*(mi|mile|miles|km|k)\b/i);
  if (!mm) return null;
  let num = parseFloat(mm[1]);
  if (!Number.isFinite(num)) return null;
  const u = mm[2].toLowerCase();
  if (u === "km" || u === "k") {
    if (unitPreference !== "Kilometers") num /= MI_TO_KM;
  } else if (unitPreference === "Kilometers") {
    num *= MI_TO_KM;
  }
  return num;
}

/** Max miles on a Long Run / Saturday Run line across the plan (internal miles for comparison). */
export function peakLongRunMilesFromPlan(planWeeks, unitPreference = "Miles") {
  if (!Array.isArray(planWeeks) || planWeeks.length === 0) return null;
  let best = null;
  for (const w of planWeeks) {
    const sched = w.schedule;
    if (!sched || typeof sched !== "object") continue;
    for (const line of Object.values(sched)) {
      const mi = parseEnduranceRunMiles(line, unitPreference);
      if (mi != null && mi > 0 && (best == null || mi > best)) best = mi;
    }
  }
  return best;
}

export function week1MileageFromPlan(planWeeks) {
  if (!Array.isArray(planWeeks) || planWeeks.length === 0) return null;
  const v = Number(planWeeks[0]?.totalMileage);
  return Number.isFinite(v) ? v : null;
}

export function peakWeeklyMileageFromPlan(planWeeks) {
  if (!Array.isArray(planWeeks) || planWeeks.length === 0) return null;
  let best = 0;
  for (const w of planWeeks) {
    const v = Number(w.totalMileage);
    if (Number.isFinite(v) && v > best) best = v;
  }
  return best;
}
